import React from 'react';
import styles from './SwatchGallery.module.scss';
import {designs} from "components/homePanels/l_customWraps/CustomWraps.data";
import {useDispatch, useSelector} from "react-redux";
import {buttonClick} from "utils/Helpers";

const SwatchGallery = (props) => {

    const wrapSelection = useSelector(state => state.wrapSelection);
    const accessible = useSelector(state => state.accessible);
    const dispatch = useDispatch();

    function setSelections(value, type){

        props.ddAction();

        let data = {}
        data[type] = value;
        if(type === 'product') data.model = null;

        dispatch({ type: "SET_WRAP_SELECTION",
            payload: {
                ...wrapSelection,
                ...data
            }
        });
    }

    function selectDesign(value){
        setSelections(value, 'design')
    }

    return (
        <div className={`${styles.wrapPatterns}`}>
                <ul>
                    {designs.map((design, i) => (
                        <li key={i}>
                            <div aria-label={`${design.owner} custom skin`} tabIndex={!accessible.modalOpen ? 0 : null} role={!accessible.modalOpen ? 'button' : null} onKeyDown={buttonClick} style={{backgroundImage: `url(${design.swatch})`}} onClick={() => selectDesign(design)}
                                 className={`${styles.swatch} ${wrapSelection.design && (wrapSelection.design === design) ? styles.selected : ''}`}>
                                <span>{design.owner}</span>
                            </div>
                        </li>
                    ))}
                </ul>
        </div>
    )
};

export default SwatchGallery
